import styled, { InfoBox, Scale } from '@secretescapes/falcon';
import { type CommonStyledProps } from '@utils/styles.utils';

export const NoAvailabilityForMonthInfoBox = styled(InfoBox)<CommonStyledProps>`
  display: flex;
  flex-direction: column;
  gap: ${Scale.xs};
  transform: ${({ isMobile }) => !isMobile && `translateY(${Scale.xxl})`};
  & > div {
    width: unset;
  }
`;

export const CalendarMonthContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.xs};
  // Used for mobile when scrolling selected month in to view
  scroll-margin-top: ${Scale.xxl};
`;
